import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

// -----------------------------------------------------------------
// I n t e r f a c e s
// -----------------------------------------------------------------
interface Props {
  date: Date;
  onStart?: any;
}

const CountDownTimer = ({ date, onStart, ...restProps }: Props) => {
  // -----------------------------------------------------------------
  // L o c a l   v a r s
  // -----------------------------------------------------------------
  // Access to i18n instance that you may use to translate your content.
  const { t } = useTranslation();

  // -----------------------------------------------------------------
  // N a v i g a t i o n   v a r s
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // S t a t e
  // -----------------------------------------------------------------
  const [_interval, set_interval] = useState<any>(null);

  const [days, setDays] = useState<any>(null);
  const [hours, setHours] = useState<any>(null);
  const [minutes, setMinutes] = useState<any>(null);
  const [seconds, setSeconds] = useState<any>(null);

  const [over, setOver] = useState<boolean>(false);

  // -----------------------------------------------------------------
  // R e f s  (DOM)
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // u s e S e l e c t o r   m e t h o d s  (redux)
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // W o r k i n g   m e t h o d s
  // -----------------------------------------------------------------

  const calcTime = (countDownDate: any) => {
    // Get today's date and time
    var now = new Date().getTime();

    // Find the distance between now and the count down date
    var distance = countDownDate - now;

    // Time calculations for days, hours, minutes and seconds
    var days = Math.floor(distance / (1000 * 60 * 60 * 24));
    var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    var seconds = Math.floor((distance % (1000 * 60)) / 1000);

    setDays(days);
    setHours(hours);
    setMinutes(minutes);
    setSeconds(seconds);

    // If the count down is finished, write some text
    if (distance < 0) {
      if (!!_interval) {
        clearInterval(_interval);
      }

      setDays(null);
      setHours(null);
      setMinutes(null);
      setSeconds(null);

      if (!over) {
        setOver(true);

        setTimeout(() => {
          onStart();
        }, 1000);
      }
    }
  };

  /**
   * Inits a timer to the fair
   * @function
   */
  const initTimer = () => {
    // Set the date we're counting down to
    var countDownDate = date.getTime();

    calcTime(countDownDate);

    // Update the count down every 1 second
    set_interval(
      setInterval(() => {
        calcTime(countDownDate);
      }, 1000)
    );
  };

  // -----------------------------------------------------------------
  // R e n d e r   m e t h o d s
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // L i f e c y c l e
  // -----------------------------------------------------------------
  /**
   * This method is called the first time the component is mounted
   * @function
   */
  const init = (): void => {
    initTimer();
  };

  /**
   * This method is called when the component is unmounted
   * @function
   */
  const destroy = (): void => {
    if (!!_interval) {
      clearInterval(_interval);
    }
  };

  // -----------------------------------------------------------------
  // u s e E f f e c t   m e t h o d s
  // -----------------------------------------------------------------
  /**
   * This hook is called once when the component is mounted
   */
  useEffect(() => {
    init();
    return () => {
      destroy();
    };
  }, []);

  // -----------------------------------------------------------------
  // T e m p l a t e
  // -----------------------------------------------------------------
  return (
    <>
      {!over && (
        <>
          <h3>{t("pages.eventDetail.will_start_in")}</h3>

          <div className="countdown">
            <div className="item">
              {days}
              <span>days</span>
            </div>
            <div className="item">
              {hours}
              <span>hours</span>
            </div>
            <div className="item">
              {minutes}
              <span>minutes</span>
            </div>
            <div className="item">
              {seconds}
              <span>seconds</span>
            </div>
          </div>
        </>
      )}

      {!!over && (
        <>
          <h3>{t("pages.eventDetail.is_starting")}</h3>
        </>
      )}
    </>
  );
};
export default CountDownTimer;
